import { KPFile } from "./KPFile";

export interface KPFolder {
  // DB Fields
  uid: number;
  guid: string;
  companyUID: number;
  folderUID: number; // 상위폴더(parent)의 UID - 0은 Root(최상위) 폴더를 의미. 그외는 자신이 속한 상위폴더의 UID를 의미
  name: string;
  depth: number; // Deprecated - 사용되지 않음

  entryDate: Date | string;
  modifyDate: Date | string;

  // NOT DB
  folders: KPFolder[]; // 하위 폴더 목록
  files: KPFile[]; // 현재 폴더의 파일 목록
  previousFolders: KPFolder[]; // 상위 폴더 목록
}

export const initializeFolder = (): KPFolder => {
  return {
    uid: 0,
    guid: "00000000-0000-0000-0000-000000000000",
    companyUID: 0,
    folderUID: 0, // 상위폴더(parent)의 UID - 0은 Root(최상위) 폴더를 의미. 그외는 자신이 속한 상위폴더의 UID를 의미
    name: "",
    depth: 0, // Deprecated - 사용되지 않음

    entryDate: new Date(),
    modifyDate: new Date(),

    // NOT DB
    folders: [] as KPFolder[], // 하위 폴더 목록
    files: [] as KPFile[], // 현재 폴더의 파일 목록
    previousFolders: [] as KPFolder[], // 상위 폴더 목록
  }
}